import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoaderService } from '../../../services/loader.service';
import { ContentState } from '../../../store/state/content.state';

@Component({
    selector: 'u4-cpp-iframe',
    templateUrl: './iframe.component.html'
})
export class IframeComponent implements OnInit, OnDestroy {

    public showTitle = true;
    public iframeUrl: SafeResourceUrl;
    public labels: { [key: string]: string };
    private destroy$: Subject<void> = new Subject<void>();
    
    constructor(
        protected loaderService: LoaderService,
        protected route: ActivatedRoute,
        protected sanitizer: DomSanitizer,
        protected store: Store<ContentState>
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);    
    }    
    
    get pageTitle(): string {
        const path = this.route.routeConfig.path;
        return this.showTitle ? this.labels[`support.title.${path}`] : null;
    }

    ngOnInit() {
        this.loaderService.addLoader(this);
        this.route.data.pipe(
            takeUntil(this.destroy$)
        ).subscribe((data: {[key: string]: boolean}) => {
            this.showTitle = data.hasOwnProperty('title') ? data.title : true;
            this.loadIframe(data, this.route.snapshot.paramMap.get('case-no') || '');
        });    
    }    
    
    removeLoader() {
        this.loaderService.removeLoader(this);
    }


    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.loaderService.removeLoader(this);
    }
    
    private loadIframe(data: {[key: string]: string | boolean}, caseNo) {
        let url = data.url as string;
        const appendQueryParams = data.urlAppendQueryParams;

        if (!url) {
            return;
        }    

        url += caseNo;

        if (appendQueryParams) {
            const params = this.route.snapshot.queryParamMap;
            const query = '?' + params.keys.map(key =>
                `${key}=${encodeURIComponent(params.get(key))}`
            ).join('&');    

            url += query;
        }    

        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }    

}
